import EVENTS from './actionTypes';
import { getVariants } from './service';

export const fetchVariants = (params) => (dispatch: any) => {
  dispatch({
    type: EVENTS.FETCH_VARIANTS_PROGRESS,
    productId: params.id,
  });
  return getVariants(params)
    .then(({ variants, productSizeData }) => {
      dispatch({
        type: EVENTS.FETCH_VARIANTS_SUCCESS,
        payload: { productSizeData, variants },
        productId: params.id,
      });
      return variants;
    })
    .catch((err) => {
      if (err.status === 404) {
        dispatch({
          type: EVENTS.FETCH_VARIANTS_NOT_FOUND,
          productId: params.id,
        });
      } else {
        dispatch({
          type: EVENTS.FETCH_VARIANTS_FAILED,
          productId: params.id,
        });
      }

      return Promise.reject(err);
    });
};
